import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../controls";
import { Entry } from "../models/Entry";

type Props = {
	setSelectedRowData: (logbookEntry: Entry | null) => void;
	setShow: (modal: "edit" | "view" | "") => void;
	setShowRemoveDialog: (show: boolean) => void;
	handleNewEntry: () => void;
};
export const useLogbookEntryOptionsFunctions = ({
	setSelectedRowData,
	setShow,
	setShowRemoveDialog,
	handleNewEntry,
}: Props) => {
	const getMenuOptions = (data: Entry) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Entry",
				key: "new_logbook_entry",
				onClick: () => handleNewEntry(),
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Entry",
					key: "edit_logbook_entry",
					onClick: () => {
						setSelectedRowData(data);
						setShow("edit");
					},
					icon: <EditIcon />,
				},
				{
					name: `Delete Entry`,
					key: "delete_logbook_entry",
					onClick: () => {
						setShowRemoveDialog(true);
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
